/* STT personalizer patch: open on the lowest-priced variant, hide the stain dropdown (swatches drive it) */
(function () {
  const C = customElements.get('stt-personalizer');
  if (!C) return;
  const P = C.prototype;
  /* The product form has an input named "id", so form.id is that input, not the form's id attribute.
     That left every personalization input unattached and nothing reached the cart. Give the form a real id and attach them. */
  /* The price block has its own small /cart/add form (for Shop Pay installments) that sits above the real one. Use the Add to cart form. */
  P.findForm = function () {
    const sec = this.closest('.shopify-section') || document;
    return sec.querySelector('product-form-component form[action*="/cart/add"]') || document.querySelector('product-form-component form[action*="/cart/add"]') || sec.querySelector('form[action*="/cart/add"]');
  };
  P.attachForm = function () {
    const f = this.findForm(); if (!f) return;
    let id = f.getAttribute('id');
    if (!id) { id = 'stt-product-form'; f.setAttribute('id', id); }
    this.querySelectorAll('input[name^="properties"]').forEach(i => { if (i.getAttribute('form') !== id) i.setAttribute('form', id); });
  };
  P.hideStainPicker = function () {
    const sel = this.optionControls(/stain|paint|color/i).find(c => c.tagName === 'SELECT');
    if (!sel) return;
    const box = sel.closest('.variant-option') || sel.closest('fieldset') || sel.parentElement.parentElement;
    if (box && box.style.display !== 'none') box.style.display = 'none';
  };
  P.applyStartVariant = async function () {
    if (this._started) return; this._started = true;
    this.addAddon();
    this.attachForm();
    /* Before every add to cart: make sure the personalization goes with it, and the letter style was chosen */
    /* window capture runs before the theme's own handlers (they listen on document) */
    window.addEventListener('submit', e => {
      const form = this.findForm();
      if (e.target !== form) return;
      this.attachForm();
      const miss = (this.tpl && this.tpl.fields || []).find(f => f.required && f.input && !f.input.value.trim());
      if (miss) {
        e.preventDefault(); e.stopImmediatePropagation();
        miss.input.classList.add('is-error'); miss.input.focus(); miss.input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        miss.input.addEventListener('input', () => miss.input.classList.remove('is-error'), { once: true });
        return;
      }
      if (this._styleChosen || !this.styleSelect()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      this.placeStyleToggle();
      const t2 = this._styleToggle; t2.classList.add('is-error'); t2.querySelector('.stt-style__err').hidden = false;
      t2.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }, true);
    /* Every sign opens on Dark Walnut with white letters */
    /* ...unless the template sets its own defaults from the example photo */
    const t0 = this.tpl || {};
    this.shown = Object.assign({}, this.shown, { stain: t0.stainDefault || 'Dark Walnut', letter: t0.letterDefault || 'White' });
    const wb = this.querySelector(`[data-letters] button[title="${this.shown.letter}"]`); if (wb) wb.click();
    if (t0.stainDefault) { this.setStain(t0.stainDefault, true); }
    this.hideStainPicker();
    new MutationObserver(() => { this.hideStainPicker(); this.placeStyleToggle(); this.placeShiplap(); }).observe(document.querySelector('variant-picker') || document.body, { childList: true, subtree: true });
    if (/[?&]variant=/.test(location.search)) return;
    const pick = (re, want) => {
      const sel = this.optionControls(re).find(c => c.tagName === 'SELECT');
      if (!sel) return false;
      const o = [...sel.options].find(want);
      if (!o || sel.value === o.value) return false;
      sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    };
    const stainStep = () => { if (this.shown && this.shown.stain) pick(/stain|paint|color/i, o => o.value.toLowerCase() === this.shown.stain.toLowerCase()); };
    /* Open on the cheapest variant: set each option (style, size) one at a time, Horizon re-renders between changes */
    const steps = [];
    try {
      const p = await (await fetch(location.pathname.replace(/\/$/, '') + '.js')).json();
      /* never open on a digital-file-only variant */
      let real = p.variants.filter(x => !(x.options || []).some(o => /digital/i.test(o)));
      /* stained-wood letters only exist as 3D letters, so a stain-letter template opens on 3D */
      if (/ Stain$/.test(t0.letterDefault || '')) { const d3 = real.filter(x => !(x.options || []).some(o => /print/i.test(o))); if (d3.length) real = d3; }
      const v = (real.length ? real : p.variants).slice().sort((a, b) => a.price - b.price)[0];
      (p.options || []).forEach((o, i) => {
        const name = typeof o === 'string' ? o : o.name;
        if (!v || /stain|paint|color/i.test(name)) return;
        const re = new RegExp(name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
        steps.push(() => pick(re, x => x.value === v.options[i]));
      });
    } catch (e) {}
    steps.push(stainStep);
    let i = 0;
    const next = () => { if (i >= steps.length) return this.readVariantState(); const changed = steps[i++](); setTimeout(next, changed ? 900 : 0); };
    next();
  };

  /* 3D Letters / UV Print Letters: the Style option shows as two buttons right above Size, and drives the preview */
  P.styleSelect = function () { return this.optionControls(/style/i).find(c => c.tagName === 'SELECT'); };
  const baseRead = P.readVariantState;
  P.readVariantState = function () {
    baseRead.call(this);
    const st = this.styleSelect && this.styleSelect();
    if (st) { this.state.print = /print/i.test(st.value); this.render(); }
    const sl = this.shiplapSelect && this.shiplapSelect();
    if (sl) { this.state.shiplap = !/^no/i.test(sl.value); this.render(); }
    this.placeStyleToggle();
    this.placeShiplap && this.placeShiplap();
  };

  /* Home decor shiplap: the Shiplap option shows as one "Add shiplap +$X" checkbox with a photo, right above Size.
     Checking it switches the variant (price updates) and draws the plank seams on the preview. */
  const SHIPLAP_IMG = 'https://cdn.shopify.com/s/files/1/0790/7439/4406/files/il_fullxfull.7353303846_ad3u.jpg';
  P.shiplapSelect = function () { return this.optionControls(/shiplap/i).find(c => c.tagName === 'SELECT'); };
  P.loadProductJson = function () {
    if (!this._pj) this._pj = fetch(location.pathname.replace(/\/$/, '') + '.js').then(r => r.json()).catch(() => null);
    return this._pj;
  };
  P.placeShiplap = function () {
    const sl = this.shiplapSelect(); if (!sl) return;
    const boxOf = c => c && (c.closest('.variant-option') || c.closest('fieldset') || c.parentElement.parentElement);
    const ob = boxOf(sl); if (ob && ob.style.display !== 'none') ob.style.display = 'none';
    let w = this._ship;
    if (!w || !w.isConnected || w.parentElement !== this) {
      w = this._ship = document.createElement('div'); w.className = 'stt-style stt-ship';
      w.innerHTML = '<p class="stt-style__label">Shiplap grooves <button type="button" class="stt-ship__link">See the difference</button></p><div class="stt-style__btns" role="group" aria-label="Shiplap grooves"><button type="button" data-ship="0">No grooves</button><button type="button" data-ship="1">Shiplap grooves <span data-ship-price></span></button></div><p class="stt-ship__note" hidden>Not available for a digital file</p>';
      const dlg = document.createElement('dialog'); dlg.className = 'stt-pz__dialog';
      dlg.innerHTML = '<button type="button" class="stt-pz__close" aria-label="Close">&times;</button><img alt="Shiplap grooves and no grooves examples">';
      dlg.querySelector('img').src = SHIPLAP_IMG + '?width=1200';
      dlg.querySelector('button').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
      document.body.appendChild(dlg);
      w.querySelector('.stt-ship__link').addEventListener('click', () => dlg.showModal());
      w.querySelectorAll('[data-ship]').forEach(btn => btn.addEventListener('click', () => {
        const s2 = this.shiplapSelect(); if (!s2 || btn.disabled) return;
        const on = btn.dataset.ship === '1';
        const want = [...s2.options].map(o => o.value).find(v => on ? !/^no/i.test(v) : /^no/i.test(v));
        if (want && s2.value !== want) { s2.value = want; s2.dispatchEvent(new Event('change', { bubbles: true })); }
        this.state.shiplap = on; this.render(); this.placeShiplap();
      }));
      this.appendChild(w);
    }
    if (this.lastElementChild !== w) this.appendChild(w);
    const on = !/^no/i.test(sl.value); this.state.shiplap = on;
    w.querySelectorAll('[data-ship]').forEach(btn => btn.setAttribute('aria-pressed', String((btn.dataset.ship === '1') === on)));
    /* Digital files have no grooves; otherwise show the up charge for the chosen size */
    const size = (this.optionControls(/size/i).find(c => c.tagName === 'SELECT') || {}).value || '';
    const digital = /digital/i.test(size);
    w.querySelector('[data-ship="1"]').disabled = digital; w.querySelector('.stt-ship__note').hidden = !digital;
    this.loadProductJson().then(pj => {
      if (!pj) return;
      const si = (pj.options || []).findIndex(o => /size/i.test(typeof o === 'string' ? o : o.name));
      const hi = (pj.options || []).findIndex(o => /shiplap/i.test(typeof o === 'string' ? o : o.name));
      const vs = pj.variants.filter(v => v.options[si] === size);
      const yes = vs.filter(v => !/^no/i.test(v.options[hi])).map(v => v.price), no = vs.filter(v => /^no/i.test(v.options[hi])).map(v => v.price);
      const d = yes.length && no.length ? Math.min(...yes) - Math.min(...no) : null;
      w.querySelector('[data-ship-price]').textContent = d != null ? '+$' + (d / 100).toFixed(2).replace(/\.00$/, '') : '';
    });
  };
  P.placeStyleToggle = function () {
    const st = this.styleSelect(); if (!st) return;
    const boxOf = c => c && (c.closest('.variant-option') || c.closest('fieldset') || c.parentElement.parentElement);
    const box = boxOf(st); if (box && box.style.display !== 'none') box.style.display = 'none';
    const sbox = boxOf(this.optionControls(/size/i).find(c => c.tagName === 'SELECT'));
    let tg = this._styleToggle;
    if (!tg || !tg.querySelector('.stt-style__btns')) {
      tg = this._styleToggle = document.createElement('div'); tg.className = 'stt-style';
      tg.innerHTML = '<p class="stt-style__label">Letters <em>*</em></p><div class="stt-style__btns" role="group" aria-label="Letter style"></div><p class="stt-style__err" hidden>Choose 3D Letters or UV Print Letters to continue.</p>';
    }
    const btns = tg.querySelector('.stt-style__btns');
    const vals = [...st.options].map(o => o.value).filter(Boolean);
    if (btns.children.length !== vals.length) {
      btns.replaceChildren(...vals.map(v => {
        const b = document.createElement('button'); b.type = 'button'; b.textContent = v; b.dataset.v = v;
        b.addEventListener('click', () => {
          this._styleChosen = true; tg.classList.remove('is-error'); tg.querySelector('.stt-style__err').hidden = true;
          const s2 = this.styleSelect(); if (!s2) return;
          if (s2.value === v) { this.placeStyleToggle(); return; }
          s2.value = v; s2.dispatchEvent(new Event('change', { bubbles: true }));
          this.state.print = /print/i.test(v); this.render(); this.placeStyleToggle();
        });
        return b;
      }));
    }
    /* Nothing looks picked until the customer taps one, so they can't overlook it */
    [...btns.children].forEach(b => b.setAttribute('aria-pressed', String(!!this._styleChosen && b.dataset.v === st.value)));
    /* Last thing inside the personalizer, which sits directly above the variant picker, so it lands right above Size.
       (Placing it between theme blocks breaks Horizon's live price update.) */
    const sh = this._ship && this._ship.parentElement === this ? this._ship : null;
    if (tg.parentElement !== this || (sh ? (tg.nextElementSibling !== sh || this.lastElementChild !== sh) : this.lastElementChild !== tg)) { if (sh) this.insertBefore(tg, sh); else this.appendChild(tg); }
  };
  if (!document.getElementById('stt-style-css')) {
    const css = document.createElement('style'); css.id = 'stt-style-css';
    css.textContent = '.stt-pz,.stt-pz__stick{min-width:0;max-width:100%}.stt-pz__preview{max-width:100%}.stt-ship__note{display:block;margin:6px 0 0;font-size:.8rem;opacity:.7}.stt-ship{margin-top:12px}.stt-ship__link{margin-left:10px;padding:0;border:0;background:none;color:inherit;font:inherit;text-decoration:underline;text-underline-offset:4px;cursor:pointer}.stt-style__btns button:disabled{opacity:.4;cursor:not-allowed}.stt-ship__note[hidden]{display:none}.stt-addon input:disabled+span{opacity:.5}.stt-style{margin:0 0 4px}.stt-style__label{margin:0 0 6px;font-size:.9rem}.stt-style__btns{display:grid;grid-template-columns:1fr 1fr;gap:8px}.stt-style__btns button{padding:12px 8px;border:1px solid rgb(0 0 0/.25);border-radius:4px;background:transparent;color:inherit;font:inherit;cursor:pointer}.stt-style__btns button[aria-pressed=true]{background:#1f2a44;border-color:#1f2a44;color:#fff}.stt-style__label em{color:#b3261e;font-style:normal}.stt-style__err{margin:6px 0 0;color:#b3261e;font-size:.85rem}.stt-style.is-error .stt-style__btns button{border-color:#b3261e;border-width:2px}';
    document.head.appendChild(css);
  }

  /* Guest books: matching "Please sign our guestbook" sign as a checkbox add-on (its own $15 product, added to the cart with the sign) */
  P.addAddon = function () {
    const a = this.cfg.addon; if (!a || !a.id || this._addon) return;
    const form = this.findForm(); if (!form) return;
    const box = this._addon = document.createElement('div'); box.className = 'stt-addon';
    box.innerHTML = `<label class="stt-addon__row"><input type="checkbox"><span class="stt-addon__text">Add a matching "Please sign our guestbook" sign <strong>+${a.price}</strong></span></label><button type="button" class="stt-addon__thumb" aria-label="See the matching sign"><img src="${a.img}" alt="Matching please sign our guestbook sign" width="64" height="64"></button>`;
    this.appendChild(box);
    const cb = box.querySelector('input');
    const dlg = document.createElement('dialog'); dlg.className = 'stt-pz__dialog';
    dlg.innerHTML = `<button type="button" class="stt-pz__close" aria-label="Close">&times;</button><img src="${a.big || a.img}" alt="Matching please sign our guestbook sign">`;
    dlg.querySelector('button').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    document.body.appendChild(dlg);
    box.querySelector('.stt-addon__thumb').addEventListener('click', () => dlg.showModal());
    form.addEventListener('submit', () => {
      if (!cb.checked) return;
      const title = (document.querySelector('h1') || {}).textContent || '';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: a.id, quantity: 1, properties: { 'Matches': title.trim() } }] }) }).catch(() => {});
    }, true);
  };
  if (!document.getElementById('stt-addon-css')) {
    const css = document.createElement('style'); css.id = 'stt-addon-css';
    css.textContent = '.stt-addon{display:flex;align-items:center;gap:12px;padding:12px;border:1px solid rgb(0 0 0/.15);border-radius:6px}.stt-addon__row{display:flex;align-items:center;gap:10px;flex:1;cursor:pointer;font-size:.92rem}.stt-addon__row input{width:20px;height:20px;flex:none}.stt-addon__thumb{flex:none;padding:0;border:0;background:none;cursor:zoom-in}.stt-addon__thumb img{display:block;width:64px;height:64px;object-fit:cover;border-radius:4px}';
    document.head.appendChild(css);
  }

  /* Horizon keeps a stale reference to the price after the first variant change, so later changes don't update it.
     After each variant change, swap in the new price ourselves. */
  if (!window._sttPriceFix) {
    window._sttPriceFix = true;
    document.addEventListener('shopify:product:select', ev => {
      if (!ev.promise || (ev.target instanceof Element && ev.target.closest('product-card'))) return;
      ev.promise.then(({ detail }) => {
        if (!detail || !detail.html) return;
        setTimeout(() => document.querySelectorAll('product-price[data-block-id]').forEach(pp => {
          if (pp.closest('product-card')) return;
          const np = detail.html.querySelector(`product-price[data-block-id="${pp.dataset.blockId}"] [ref="priceContainer"]`);
          const cur = pp.querySelector('[ref="priceContainer"]');
          if (np && cur && cur.textContent.trim() !== np.textContent.trim()) cur.replaceWith(np.cloneNode(true));
        }), 60);
      }).catch(() => {});
    }, true);
  }

  /* Shared wedding details: saved in this browser, fills every personalizer, and anything typed on one sign carries to the next */
  const KEY = 'stt_couple';
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } };
  const save = d => { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} };
  /* Only the wedding date is shared; other date lines (First Day, Yes Day) are left for the customer */
  const role = (k, f) => /initial|monogram/i.test(k) ? 'initial' : /last|family|surname/i.test(k) ? 'last'
    : /^(wedding )?date$|^est/i.test(k) ? 'date' : (f && f.dateStyle) || /day|date/i.test(k) ? null
    : /^name ?1$/i.test(k) ? 'first1' : /^name ?2$/i.test(k) ? 'first2'
    : /^names?$|couple/i.test(k) ? 'names' : null;
  /* Dates are stored as 11.13.2026. Designs whose date field has dateStyle 'words' show NOVEMBER 13, 2026
     (the customer can still type numbers there); numeric-only designs always get numbers. */
  const MONTHS = ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER'];
  const toWords = n => { const m = (n || '').match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{2,4})$/); if (!m) return n; const y = m[3].length === 2 ? '20' + m[3] : m[3]; return `${MONTHS[+m[1] - 1] || m[1]} ${+m[2]}, ${y}`; };
  const toNum = w => { const m = (w || '').toUpperCase().match(/^([A-Z]+)\.?\s+(\d{1,2}),?\s+(\d{4})$/); if (!m) return w; const i = MONTHS.findIndex(x => x.startsWith(m[1].slice(0, 3))); if (i < 0) return w; return `${String(i + 1).padStart(2, '0')}.${m[2].padStart(2, '0')}.${m[3]}`; };
  P.sttDate = { toWords, toNum };
  const valueFor = (r, d, f) => {
    if (r === 'names') return d.first1 && d.first2 ? `${d.first1} & ${d.first2}` : (d.first1 || '');
    if (r === 'first1') return d.first1 || '';
    if (r === 'first2') return d.first2 || '';
    if (r === 'last') return d.last || '';
    if (r === 'date') return f && f.dateStyle === 'words' ? toWords(d.date || '') : (d.date || '');
    if (r === 'initial') return (d.last || '').trim().charAt(0).toUpperCase();
    return '';
  };
  P.applyCouple = function () {
    const d = load();
    (this.tpl.fields || []).forEach(f => {
      const r = role(f.key, f); if (!r || !f.input) return;
      const v = valueFor(r, d, f);
      if (v && !f.input.value.trim()) { f.input.value = v; f.input.dispatchEvent(new Event('input', { bubbles: true })); }
      if (!f.input._sttSave) {
        f.input._sttSave = true;
        f.input.addEventListener('change', () => {
          const v = f.input.value.trim(), cur = load();
          if (r === 'names') { const m = v.split(/\s*(?:&|\+|\band\b)\s*/i); cur.first1 = m[0] || ''; cur.first2 = m[1] || ''; }
          else if (r === 'first1') cur.first1 = v;
          else if (r === 'first2') cur.first2 = v;
          else if (r === 'last') cur.last = v.replace(/^the\s+/i, '').replace(/'s$/i, '');
          else if (r === 'date') { cur.date = toNum(v); if (f.dateStyle !== 'words' && cur.date !== v && /^\d/.test(cur.date)) { f.input.value = cur.date; f.input.dispatchEvent(new Event('input', { bubbles: true })); } }
          else return;
          save(cur);
        });
      }
    });
  };
  document.querySelectorAll('stt-personalizer').forEach(el => { const go = () => el.tpl ? el.applyCouple() : setTimeout(go, 100); go(); });
})();

/* Keep the floating preview short enough that the form below it stays reachable */
(function () {
  const fit = () => document.querySelectorAll('.stt-pz__preview').forEach(p => {
    const a = (getComputedStyle(p).aspectRatio || '').split('/').map(parseFloat);
    if (a.length !== 2 || !a[0] || !a[1]) return;
    p.style.maxWidth = Math.round(innerHeight * (innerWidth < 750 ? 0.34 : 0.42) * a[0] / a[1]) + 'px';
    p.style.marginInline = 'auto';
    const st = p.closest('.stt-pz__stick'); if (st) { let el = st.parentElement, bg = ''; while (el && (!bg || bg === 'rgba(0, 0, 0, 0)')) { bg = getComputedStyle(el).backgroundColor; el = el.parentElement; } st.style.background = bg && bg !== 'rgba(0, 0, 0, 0)' ? bg : '#fff'; st.style.paddingBottom = '6px'; }
  });
  addEventListener('resize', fit);
  [300, 1000, 2500].forEach(t => setTimeout(fit, t));
})();
